import api from './api'

export interface Address {
  line_1: string
  line_2?: string
  line_3?: string
  post_town: string
  postcode: string
  county?: string
  country: string
  formatted: string
  udprn?: string
  latitude?: number
  longitude?: number
}

export interface PostcodeLookupResponse {
  success: boolean
  message: string
  addresses?: Address[]
}

export interface AutocompleteSuggestion {
  suggestion: string
  url: string
  udprn: string
}

export interface AutocompleteResponse {
  success: boolean
  message: string
  suggestions?: AutocompleteSuggestion[]
}

export const postcodeService = {
  /**
   * Lookup addresses by postcode
   */
  async lookup(postcode: string): Promise<PostcodeLookupResponse> {
    const response = await api.post<PostcodeLookupResponse>('/addresses/lookup', {
      postcode,
    })
    return response.data
  },

  /**
   * Autocomplete address as user types
   */
  async autocomplete(query: string, limit: number = 10): Promise<AutocompleteResponse> {
    const response = await api.post<AutocompleteResponse>('/addresses/autocomplete', {
      query,
      limit,
    })
    return response.data
  },

  /**
   * Get full address by UDPRN
   */
  async getAddress(udprn: string): Promise<Address> {
    const response = await api.get<Address>(`/addresses/address/${udprn}`)
    return response.data
  },

  /**
   * Validate postcode format and existence
   */
  async validate(postcode: string): Promise<{ valid: boolean; message: string }> {
    const response = await api.get(`/addresses/validate/${postcode}`)
    return response.data
  },
}
